import { useState, useEffect, useContext } from "react";
import { GameContext } from "../context/GameContext";

export default function MatchLetterButton({ letter }) {
  const { selectedLetters, handleClickLetterBtn, error } =
    useContext(GameContext);
  const [isSelected, setIsSelected] = useState(false);

  useEffect(() => {
    if (selectedLetters.includes(letter)) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [selectedLetters, letter]);

  return (
    <>
      <button
        value={letter.id}
        onClick={(e) => {
          handleClickLetterBtn(e);
        }}
        disabled={error ? true : false}
        className={`matchLetter animate__bounceIn shadow-md transition ease-in-out text-white

        ${isSelected ? "bg-blue-800" : "gradients"}

        ${error ? "letterDisabled" : ""}
        
        `}
      >
        {letter.value}
      </button>
    </>
  );
}
